// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import React, { FC } from "react";
import SignedOutFullLayout from "@store/Library/Components/SignedOut/SignedOutFullLayout";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";

const enum fields {
    logo = "logo",
    showContactUs = "showContactUs",
}

export interface AccountApplicationCreditProps extends WidgetProps {
    fields: {
        [fields.logo]: string;
        [fields.showContactUs]: boolean;
    };
}

export interface AccountApplicationCreditStyles {
    title?: TypographyPresentationProps;
}

export const accountApplicationCreditStyles: AccountApplicationCreditStyles = {
    title: { variant: "h1" },
};

const styles = accountApplicationCreditStyles;

const AccountApplicationCredit: FC<AccountApplicationCreditProps> = ({ fields: { logo, showContactUs } }) => {
    const currentPage = useCurrentPage();

    return (
        <SignedOutFullLayout
            data-test-selector="accountApplicationCredit"
            headerProps={{ logo, showContactUs, isProspectUser: true }}
        >
            <Typography {...styles.title}>{currentPage.fields.title}</Typography>
        </SignedOutFullLayout>
    );
};

const widgetModule: WidgetModule = {
    component: AccountApplicationCredit,
    definition: {
        displayName: "Account Application Credit",
        group: constants.widgetGroup.accountApplication,
        allowedContexts: [constants.pageType.accountApplicationCredit],
        fieldDefinitions: [
            {
                name: fields.logo,
                displayName: "Logo",
                editorTemplate: "ImagePickerField",
                defaultValue: constants.logoPath,
                fieldType: "Contextual",
            },
            {
                name: fields.showContactUs,
                displayName: "Show Contact Us",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
